"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.airInput = exports.target = exports.fanOperationalRange = exports.motorDefinition = exports.fanPerformanceMmodel = exports.fanDefinition = exports.fanQuantity = exports.fanControlMode = void 0;
exports.fanControlMode = "fptcontrolmode";
exports.fanQuantity = "fptfanquantity";
exports.fanDefinition = "fptfandefinition";
exports.fanPerformanceMmodel = "fptfanperformancemodel";
exports.motorDefinition = "fptmotordefinition";
exports.fanOperationalRange = "fptfanoperationalrange";
exports.target = "target";
exports.airInput = "airinput";
//# sourceMappingURL=group-names.js.map